import i18next from "i18next";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import {
  Route,
  RouteComponentProps,
  Switch,
  useHistory,
  useRouteMatch
} from "react-router";
import { authStoreContext } from "../../core/mainStore";
import { CustomerRowButtons } from "./CustomerRowButtons";
import { customerContext, CustomerSchema } from "./schema";
import {
  AdminRoute,
  CreateView,
  IndexView,
  ShowView,
  withBreadCrumbs
} from "lego-gui-lib/lib";

export const Customers: AdminRoute = {
  url: "/customers",
  handler: (props: RouteComponentProps) => {
    const title = i18next.t("hns:customer:domain_plural");
    const baseUrl = props.match.url;

    return withBreadCrumbs(
      { to: baseUrl, children: title },
      <>
        <Switch>
          <Route exact={true} path={baseUrl} component={Index} />
          <Route path={baseUrl + "/create/:id"} component={Create} />
          <Route path={baseUrl + "/create"} component={Create} />
          <Route path={baseUrl + "/:id"} component={Show} />
        </Switch>
      </>
    );
  }
};

export const Index = observer(({ ...rest }: any) => {
  const auth = useContext(authStoreContext);
  const customer = useContext(customerContext);

  const i18n = useTranslation();
  const title = i18n.t("hns:customer:domain", { count: 2 });

  const canCreate = auth.isAdmin();
  const canSelectCustomerContext = auth.isAnyCustomerOwner();

  return (
    <IndexView
      dataSource={customer.listDataSource}
      {...rest}
      title={title}
      titleButtons={() => !canCreate && <></>}
      toolbarButtons={{ delete: canCreate, export: false }}
      disableCheckboxes={canCreate ? undefined : true}
      rowButtons={CustomerRowButtons(canCreate, canSelectCustomerContext)}
      columns={CustomerSchema}
    />
  );
});

export const Create = observer(({ ...rest }: any) => {
  const customer = useContext(customerContext);

  const i18n = useTranslation();
  const title = i18n.t("common:create", { domain: "hns:customer:domain" });

  const match = useRouteMatch();
  const baseUrl = match.url;
  const history = useHistory();

  return withBreadCrumbs(
    { to: baseUrl + "/create", children: title },
    <CreateView
      dataSource={customer.oneDataSource}
      {...rest}
      title={title}
      fields={CustomerSchema}
      id={match.params}
      goBack={() => history.goBack()}
    />
  );
});

export const Show = observer(() => {
  const customer = useContext(customerContext);

  const i18n = useTranslation();
  const title = i18n.t("common:edit", { domain: "hns:customer:domain" });

  const match = useRouteMatch();
  const baseUrl = match.url;
  const history = useHistory();

  return withBreadCrumbs(
    { to: baseUrl + "/edit", children: title },
    <ShowView
      dataSource={customer.oneDataSource}
      title={title}
      fields={CustomerSchema}
      id={match.params}
      goBack={() => history.goBack()}
    />
  );
});
